import { collectShopperContext } from "./context";
import { observeBehavior } from "./behavior";
import { chooseTrigger } from "./decision-engine";
import { GemSalesRenderer } from "./renderer";
import { observeSections } from "./sections";
import { hydrateThemeFromHost } from "./theme-adapter";
import { GemSalesTracker } from "./tracker";
import { mountSurfaceChips } from "./surface/runtime-bridge";
import { GemSalesConfig } from "./types";

export interface GemSalesInstance {
  destroy: () => void;
}

export function startGemSales(config: GemSalesConfig): GemSalesInstance {
  const hydratedConfig = hydrateThemeFromHost(config);
  const context = collectShopperContext(hydratedConfig.shopId);
  const tracker = new GemSalesTracker(hydratedConfig, context);
  const renderer = new GemSalesRenderer(hydratedConfig, context, tracker);

  tracker.track("gemsales.sdk.loaded", {
    mode: hydratedConfig.mode,
    acquisition: context.acquisition,
  });

  const renderBestTrigger = () => {
    const trigger = chooseTrigger(hydratedConfig, context);
    if (trigger) renderer.renderTrigger(trigger);
  };

  const stopObserving = observeSections((sectionType) => {
    context.seenSections.add(sectionType);
    tracker.track("gemsales.section.seen", { section_type: sectionType });
    renderBestTrigger();
  });
  const stopBehavior = observeBehavior(hydratedConfig, context, tracker);

  window.setTimeout(renderBestTrigger, 800);

  const surfaceChips = hydratedConfig.surfaceEndpoint
    ? mountSurfaceChips(hydratedConfig, context, {
        endpoint: hydratedConfig.surfaceEndpoint,
        emit: (event, props) => tracker.track(event, props ?? {}),
      })
    : null;

  return {
    destroy: () => {
      stopObserving();
      stopBehavior();
      renderer.destroy();
      surfaceChips?.destroy();
      tracker.track("gemsales.sdk.destroyed");
    },
  };
}
